// validation.js
export const validateField = (field, value) => {
    let error = '';
    switch (field) {
        case 'name':
        case 'address':
        case 'trade': 
        case 'communityName': 
        case 'lastName': 
        case 'firstName':
        case 'permitType':
            if (!value) error = `${toReadableFormat(field)} is required`;
            break;
        case 'email':
        case 'workEmail':
        case 'communityEmail':
            const emailRegex = /^\S+@\S+\.\S+$/;
            if (!value) error = 'Email is required';
            else if (!emailRegex.test(value)) error = 'Invalid email format';
            break;
        case 'zip':
        case 'zipcode':
            if (!value) error = 'Zip code is required';
            else if (!/^\d+$/.test(value)) error = 'Zip code must be numeric';
            break;
        case 'phoneNumber':
        case 'communityPhoneNumber':
            if (!value) error = 'Phone number is required';
            else {
                // Remove dashes and check if we have exactly 10 digits
                const digitsOnly = value.replace(/\D/g, '');
                if (digitsOnly.length !== 10) {
                    error = 'Phone number must be 10 digits (e.g., 630-408-9149)';
                } else if (!/^[0-9]{10}$/.test(digitsOnly)) {
                    error = 'Phone number must be valid (e.g., 630-408-9149)';
                }
            }
            break;
        case 'individualName':
            if (!value) error = `Individual Name is required`;
            break;    
        case 'cost':
            if (!value) error = `Estimated Cost is required`;
            else {
                const numericValue = parseFloat(value.replace(/[$,]/g, ""));
                if (isNaN(numericValue)) {
                    error = "Estimated Cost must be a valid number";
                } else if (numericValue <= 0) {
                    error = "Estimated Cost must be a positive number";
                }
            }
            break;     
        case 'notes':
        case 'description':
            if (!value) error = `${toReadableFormat(field)} is required`;    
            else if (value && value.length < 10) error = `Please add at least 10 characters for ${field}`;
            break;   
        default:
            break;
    }
    return error;
};


const toReadableFormat = (str) => {
    return str
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (match) => match.toUpperCase())
        .trim();
};
